module.exports = __webpack_public_path__ + "img/post_1.edcf226a.jpg";